import React from 'react';
import { RouteObject } from 'react-router-dom';

import DisableTextSelectionWrapper from '@/components/Common/Wrapper/DisableTextSelectionWrapper';
import BaseSuperTopup from '@/pages/super-top-up/BaseSuperTopup';

const StuHome = React.lazy(() => import('@/pages/super-top-up/home/index'));
const StuSelectMember = React.lazy(
  () => import('@/pages/super-top-up/select-member'),
);
const StuPlans = React.lazy(() => import('@/pages/super-top-up/plans'));
const StuKyc = React.lazy(() => import('@/pages/super-top-up/kyc'));
const StuProposal = React.lazy(() => import('@/pages/super-top-up/proposal'));
const StuProposalReview = React.lazy(
  () => import('@/pages/super-top-up/proposal/review'),
);
const StuPayment = React.lazy(() => import('@/pages/super-top-up/payment'));
const StuPolicy = React.lazy(() => import('@/pages/super-top-up/policy'));
const StuThankYou = React.lazy(
  () => import('@/pages/super-top-up/thank-you/index'),
);
const StuError = React.lazy(() => import('@/pages/super-top-up/error/index'));

/**
 * The Care Super Top-up journey under `/retail/super-top-up`, mounted beside
 * `healthInsuranceRoutes`. Its pages, hooks and context are its own: it shares none with the
 * retail health insurance journey. The payment returns and the benefits page sit at the top
 * level in `routes.tsx`, like the retail returns.
 */
export const superTopupRoutes: RouteObject[] = [
  {
    path: 'super-top-up',
    element: (
      <DisableTextSelectionWrapper>
        <BaseSuperTopup />
      </DisableTextSelectionWrapper>
    ),
    children: [
      {
        path: '',
        element: <StuHome />,
      },
      {
        path: 'select-member',
        element: <StuSelectMember />,
      },
      {
        // The plan step owns the option and its add-ons; there is no per-plan page.
        path: 'plans',
        element: <StuPlans />,
      },
      {
        path: 'kyc/:planId',
        element: <StuKyc />,
      },
      {
        path: 'proposal/:planId',
        element: <StuProposal />,
      },
      {
        path: 'proposal/:planId/review',
        element: <StuProposalReview />,
      },
      {
        path: 'payment/:planId',
        element: <StuPayment />,
      },
      {
        path: 'policy/:planId',
        element: <StuPolicy />,
      },
      {
        path: 'thank-you',
        element: <StuThankYou />,
      },
      {
        path: 'error',
        element: <StuError />,
      },
    ],
  },
];
